import { GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import groupsEmptyStateIllustration from '@gitlab/svgs/dist/illustrations/empty-state/empty-groups-md.svg?url';
import ResourceListsEmptyState from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/resource_lists/empty_state.vue?vue3';
import HelpPageLink from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/help_page_link/help_page_link.vue?vue3';
import { s__ } from '~/locale';
import { SEARCH_MINIMUM_LENGTH } from '../../constants';
export default {
    name: 'SharedGroupsEmptyState',
    components: {
        ResourceListsEmptyState,
        GlSprintf,
        HelpPageLink
    },
    SEARCH_MINIMUM_LENGTH,
    groupsEmptyStateIllustration,
    i18n: {
        title: s__('GroupsEmptyState|This group has not been invited to any other groups.'),
        description: s__('GroupsEmptyState|Other groups this group has been %{linkStart}invited to%{linkEnd} will appear here.')
    },
    props: {
        search: {
            type: String,
            required: false,
            default: ''
        }
    }
};
